import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlug = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.5 5.5a1.5 1.5 0 1 0-3 0V11h3V5.5Zm-12 0a1.5 1.5 0 1 0-3 0V11h3V5.5ZM31 13H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v4c0 5.009 3.694 9.12 8.5 9.849V36h3v-6.151C26.306 29.12 30 25.009 30 20v-4h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-4 7a7 7 0 1 1-14 0v-4h14v4Z" })
});
export default SvgPlug;
